// extracted by mini-css-extract-plugin
module.exports = {"occupanciesContainer":"rate_plan_occupancy_occupanciesContainer__3IwMO","occupancyCell":"rate_plan_occupancy_occupancyCell__2zu2E"};